import { render, staticRenderFns } from "./warranty-claims.vue?vue&type=template&id=871f6fc6&scoped=true&"
import script from "./warranty-claims.vue?vue&type=script&lang=ts&"
export * from "./warranty-claims.vue?vue&type=script&lang=ts&"
import style0 from "./warranty-claims.vue?vue&type=style&index=0&id=871f6fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871f6fc6",
  null
  
)

export default component.exports